import {
  accordionFields,
  articleStoryFields,
  buildSectionFields,
  cardFields,
  filteredMerchantsFields,
  financialServicesBannerFields,
  merchantListFields,
  superHeroFields,
  titleCopyCtaBlockFields,
  versatileCardFields,
  heroFields,
  dynamicVersatileCardFields,
  buttonFields,
  carouselFavouritesFields,
} from '../../providers/contentful';

const sectionFields = buildSectionFields({
  fieldName: 'sectionFields',
  contentCollectionLimit: 5,
  contentRowItemsLimit: 10,
  versatileCard: true,
  dynamicVersatileCard: true,
  titleCopyCtaBlock: true,
  articleStory: true,
  merchantList: true,
  filteredMerchants: true,
  superHero: true,
  accordian: true,
  financialServicesBanner: true,
  card: true,
  textBlock: true,
  button: true,
  carouselFavourites: true,
});

export const collectOnlinePageQuery = `query CollectOnlinePageQuery($opco: String!, $locale: String!, $market: String!) {
    microcopyCollection(locale: $locale, where: {
      key_in: [
        "collectOnline.pageTitle"
        "collectOnline.section.ariaLabel.partnersSection"
        "merchant.ratewas"
        "merchant.rateupto"
        "merchant.ratefrom"
      ]
    }) {
      items {
        key
        value
      }
    }
    pageCollectOnlineCollection(
        limit: 1
        locale: $locale
        where: {opco: $opco, market: $market}
      ) {
        items {
          name
          pageTitle
          title
          topSectionCollection(limit: 15) {
            items {
              ...sectionFields
            }
          }
          heroSection {
            ...heroSectionFields
          }
        }
      }
      }
    ${sectionFields}
    ${versatileCardFields}
    ${dynamicVersatileCardFields}
    ${titleCopyCtaBlockFields}
    ${articleStoryFields}
    ${merchantListFields}
    ${filteredMerchantsFields}
    ${superHeroFields}
    ${accordionFields}
    ${financialServicesBannerFields}
    ${cardFields}
    ${heroFields}
    ${buttonFields}
    ${carouselFavouritesFields}
    `;
